import * as ng from 'angular';
import {RootScope} from "../../types/angular-types";
import {
    ApprovalInfo,
    ApprovalService,
    DescribeApprovalIncludeTypes,
    DescribeApprovalOwnerSortTypes
} from "../approvals-types";
import SignalProvider from "../../gorillaboy/SignalProvider";
import AppConstants from "../../gorillaboy/AppConstants";

angular.module("GorillaBoy.Approvals")
.controller('ApprovalRequestsListController', ApprovalRequestsListControllerFn);
ApprovalRequestsListControllerFn.$inject = ['$scope', '$log', 'DateTimeService', 'ApprovalService'];

interface IScope extends RootScope {
    approvalRequestsLoadingMore: boolean;
    pageMarker: string;
    currentSortColumn: string;
    sortOrderAscending: boolean;
    approvalRequestsLoadingError: boolean;
    approvalRequestsLoading: boolean;
    approvalRequests: ApprovalInfo[];
    show: string;

    getReadableDate: (dateParam : Date) => string;
    toggleOrSetSortOrder: (columnName: string) => void;
}

function ApprovalRequestsListControllerFn($scope : IScope, $log : ng.ILogService,
                                        DateTimeService : any, ApprovalService: ApprovalService) {
    //Methods on scope --- start
    $scope.toggleOrSetSortOrder = (columnName: string) => {
        if (columnName === $scope.currentSortColumn) {
            $scope.sortOrderAscending = !$scope.sortOrderAscending;
        } else {
            $scope.currentSortColumn = columnName;
            $scope.sortOrderAscending = false;
        }

        resetListViewData();
        updateApprovals();
    };
    $scope.getReadableDate = DateTimeService.getHumanReadableDate;
    //Methods on scope --- end

    //Init scope --- start
    $scope.sortOrderAscending = false;
    $scope.currentSortColumn = AppConstants.APPROVAL_LIST_VIEW.SORT_COLUMNS.DATE;
    let include : DescribeApprovalIncludeTypes = null;
    let sort : DescribeApprovalOwnerSortTypes = DescribeApprovalOwnerSortTypes.LASTMODIFIEDDATE;
    if ($scope.show === AppConstants.APPROVAL_VIEW_TYPES.ASSIGNED) {
        include = DescribeApprovalIncludeTypes.ASSIGNED;
        sort = null;
    } else if ($scope.show === AppConstants.APPROVAL_VIEW_TYPES.TAKENACTION) {
        include = DescribeApprovalIncludeTypes.TAKENACTION;
        sort = null;
    }

    resetListViewData();
    updateApprovals();
    //Init scope --- end

    //Scope event handlers -- start
    $scope.$on(SignalProvider.ContentLoading.LoadMore, function($event, data) {
        if ($scope.approvalRequestsLoadingMore) {
            return;
        }
        $scope.approvalRequestsLoadingMore = true;

        $scope.$broadcast(SignalProvider.ContentLoading.Start);
        updateApprovals();
        $event.stopPropagation();
    });
    //Scope event handlers -- end

    function getOrderType() {
        if ($scope.sortOrderAscending) {
            return AppConstants.SORT_ORDER.ASCENDING;
        }
        return AppConstants.SORT_ORDER.DESCENDING;
    }

    function updateApprovals() {
        ApprovalService.DescribeApprovals(include, sort, getOrderType(), $scope.pageMarker)
            .then(response => {
                $scope.approvalRequests = $scope.approvalRequests.concat(response.ApprovalInfos);
                $scope.pageMarker = response.Marker;
            }, () => {
                $scope.approvalRequestsLoadingError = true;
            })
            .finally(() => {
                $scope.approvalRequestsLoading = false;
                $scope.approvalRequestsLoadingMore = false;
                $scope.$broadcast(SignalProvider.ContentLoading.Done);
            });
    }

    function resetListViewData() {
        $scope.approvalRequestsLoading = true;
        $scope.approvalRequestsLoadingError = false;
        $scope.pageMarker = null;
        $scope.approvalRequests = [];
    }


}
